let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jQyRw")).then(() => parcelRequire('6CpHo'));